import React from "react";
import { motion } from "framer-motion";
import { AlertTriangle, Package, Calendar, TrendingDown, Landmark, Droplet } from "lucide-react";
import { format, parseISO } from "date-fns";

export default function AlertsPanel({ insumosBaixos, contasAtrasadas, safrasAtivas, parcelasProximas = [], financiamentos = [], manejosProximos = [], qualidadeAlertas = null }) {
  const alerts = [];

  if (parcelasProximas.length > 0) {
    const valorTotal = parcelasProximas.reduce((acc, p) => acc + (p.valor_total || 0), 0);
    alerts.push({
      type: "warning",
      icon: Landmark,
      title: "Parcelas Próximas",
      message: `${parcelasProximas.length} parcela(s) nos próximos 30 dias (R$ ${valorTotal.toLocaleString('pt-BR', { minimumFractionDigits: 2 })})`,
      color: "bg-indigo-50 border-indigo-200 text-indigo-700"
    });
  }

  if (insumosBaixos.length > 0) {
    alerts.push({
      type: "warning",
      icon: Package,
      title: "Estoque Baixo",
      message: `${insumosBaixos.length} insumo(s) abaixo do mínimo`,
      color: "bg-amber-50 border-amber-200 text-amber-700"
    });
  }

  if (contasAtrasadas.length > 0) {
    alerts.push({
      type: "danger",
      icon: TrendingDown,
      title: "Contas Atrasadas",
      message: `${contasAtrasadas.length} pagamento(s) pendente(s)`,
      color: "bg-red-50 border-red-200 text-red-700"
    });
  }

  if (safrasAtivas.length > 0) {
    alerts.push({
      type: "info",
      icon: Calendar,
      title: "Safras em Andamento",
      message: `${safrasAtivas.length} safra(s) ativa(s)`,
      color: "bg-blue-50 border-blue-200 text-blue-700"
    });
  }

  if (manejosProximos.length > 0) {
    const vacinas = manejosProximos.filter(m => m.tipo === 'vacina').length;
    const vermifugacoes = manejosProximos.filter(m => m.tipo === 'vermifugacao').length;
    const tratamentos = manejosProximos.filter(m => m.tipo === 'tratamento').length;
    alerts.push({
      type: "info",
      icon: Calendar,
      title: "Manejos de Saúde Próximos",
      message: `${manejosProximos.length} manejo(s) nos próximos 30 dias • vacina ${vacinas}, vermifugação ${vermifugacoes}, tratamento ${tratamentos}`,
      color: "bg-emerald-50 border-emerald-200 text-emerald-700"
    });
  }

  if (qualidadeAlertas) {
    alerts.push({
      type: "warning",
      icon: Droplet,
      title: "Qualidade do Leite",
      message: `CCS acima: ${qualidadeAlertas.acimaCCS} • CBT acima: ${qualidadeAlertas.acimaCBT}`,
      color: "bg-amber-50 border-amber-200 text-amber-700"
    });
  }

  if (alerts.length === 0) {
    return (
      <div className="bg-white rounded-2xl shadow-sm border border-stone-200 p-6">
        <h3 className="font-bold text-lg text-stone-800 mb-4 flex items-center gap-2">
          <AlertTriangle className="w-5 h-5 text-[#D4A373]" />
          Alertas
        </h3>
        <div className="text-center py-8 text-stone-500">
          <p>Nenhum alerta no momento</p>
          <p className="text-sm mt-1">Tudo em ordem! 🌱</p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-2xl shadow-sm border border-stone-200 p-6">
      <h3 className="font-bold text-lg text-stone-800 mb-4 flex items-center gap-2">
        <AlertTriangle className="w-5 h-5 text-[#D4A373]" />
        Alertas
      </h3>
      
      <div className="space-y-3">
        {alerts.map((alert, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
            className={`p-4 rounded-xl border ${alert.color}`}
          >
            <div className="flex items-center gap-3">
              <alert.icon className="w-5 h-5 flex-shrink-0" />
              <div>
                <p className="font-medium">{alert.title}</p>
                <p className="text-sm opacity-80">{alert.message}</p>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
